export const DOMAIN = 'SelectHorizontalItem';
// The following are commonly tweaked
export const SPACE_BETWEEN = 2;
export const FONT_SIZE = 15;
export const FIXED_WIDTH = 78;
export const ARROW_WIDTH = 20;
